export default __webpack_public_path__ + "static/media/startTradeIcon1.6cea2943.webp";